module.exports = __webpack_public_path__ + "assets/aa81663df9a0e9ed4fa5228f8eae4e11.png";